import React, { Component } from 'react';
import './App.css';
import Hero from './components/Hero'

class App extends Component {
  render() {
    return (
      <div className="App">
        <Hero />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js